import React, { Component } from 'react'
import $ from 'jquery'
import axios from 'axios';
import * as Common from '../../../static/js/Common';

import { DongPrivate } from '../login/DongPrivate';
import Post from "../../daumPostcode/Post";
import { DataPicker2 } from "../../picker/DataPicker2";
import { AlertMessagePopup } from '../../popup/AlertMessagePopup';

import '../../../static/css/application.css';
import headLogo from '../../../static/image/v2/application/headLogo.png';
import arrow from '../../../static/image/v2/application/arrow.png';
import service1 from '../../../static/image/v2/application/service1.png'
import service2 from '../../../static/image/v2/application/service2.png'
import { DongDeliveryService } from '../login/DongDeliveryService';
import {ReactComponent as HeadText} from "assets/images/headText.svg";
import {shopMapping} from "../../../static/js/service/mappingService";
import {getValue} from "../../../static/js/Common2";
import { BACK_OFFICE_API, LOGIN_API, POS_API, ORDER_API, ORDER_PROXY_API} from 'constants/apiUrls';


class DongApplicationV2 extends Component {
  async componentDidMount() {

    $(document).ready(function() {
      $('.Header').addClass('hide');
      $('.Subnav').addClass('hide');
      $('.Subnav ul').addClass('hide');
    });

    $('.closeBtn').off('click').on('click', function () {
      $('.popup').addClass('hide')
    })

    $("#email3").on("change", function() {
      if($(this).val() === "직접입력") {
        $('#email2').val("");
        $("input[name=email2]").prop("readonly", false);
      }
      else {
        $('#email2').val($(this).val());
        $("input[name=email2]").prop("readonly", true);
      }
    });


    let service = ""
    let number = /[^0-9]/gi;
    let eng = /[^a-zA-Z0-9._]/gi;
    var pwChk = /^(?=.*[a-zA-z])(?=.*[0-9])(?=.*[$`~!@$!%*#^?&\\(\\)\-_=+]).{8,16}$/;

    // 본인인증
    /*
    $(".mobileCheckBtn").off("click").on("click", function() {
      var code = $("#verificationCode");
      var codeBtn = $("#codeBtn")
      var tel1 = String($("#tel1").val())
      var tel2 = String($("#tel2").val())
      var tel3 = String($("#tel3").val())
      var tel = tel1 + tel2 + tel3

      if(code.val() !== "") {
        axios({
          method: "post",
          url: `${ LOGIN_API }/cert/phone/check`,
          data: {
            channelType: 2,
            tel: String(tel),
            certNumber: String(code.val())
          }
        }).then(function(response) {
          if (response.data.testResult === false) {
            codeBtn.attr("data", "0");
            $("#AlertMessagePopup1_3").removeClass("hide")
          } else {
            codeBtn.attr("data", "1");
            $("#AlertMessagePopup1_4").removeClass("hide")
          }
        }).catch(function (error) {
          console.log(error);
        })
      } else {
        $("#AlertMessagePopup1_5").removeClass("hide")
        return false;
      }
    });
    */

    // 본인인증코드 발급
    /*
    var mobileChk = /^(?:(010\d{4})|(01[1|6|7|8|9]\d{3,4}))(\d{4})$/;

    $(".mobileBtn").off("click").on("click", function() {
      var tel1 = String($("#tel1").val())
      var tel2 = String($("#tel2").val())
      var tel3 = String($("#tel3").val())
      var tel = tel1 + tel2 + tel3

      if(tel.length === 11) {
        if(!mobileChk.test(tel)) {
          $("#AlertMessagePopup1_6").removeClass("hide")
          return false;
        } else {
          axios({
            method: "post",
            url: `${ LOGIN_API }/cert/phone`,
            data: {
              tel: tel,
            }
          }).then(function() {
            $(".verificationCode").removeClass("hide");
            $(".mobileCheckBtn").removeClass("hide");
          }).catch(function (error) {
            console.log(error);
          })
        }
      } else {
        $("#AlertMessagePopup1_7").removeClass("hide")
        return false;
      }
    });
    */

    // 입력 제한
    $('.number').on("focusout", function(){
      var x = $(this).val();
      if (x.lengt > 0){
        if (x.match(number)){
          x = x.replace(number, "");
        }
        $(this).val(x);
      }
    }).on("keyup", function() {
      $(this).val($(this).val().replace(number, ""));
    });

    $('.eng').on("focusout", function(){
      var x = $(this).val();
      if (x.lengt > 0){
        if (x.match(eng)){
          x = x.replace(eng, "");
        }
        $(this).val(x);
      }
    }).on("keyup", function() {
      $(this).val($(this).val().replace(eng, ""));
    });

    let categoryService = await axios.get(
      `${ BACK_OFFICE_API }/category/all`, {
        params: {
          chanlTpcd: 2
        }
      }
    )

    $("#businessClass1").on("click", function() {
      $(".corporationBox").addClass("hide")
      $("#corporation1").val("")
      $("#corporation2").val("")
    })
    $("#businessClass2").on("click", function() {
      $(".corporationBox").removeClass("hide")
    })

    let categoryOutput = categoryService.data.reduce(function(a, b) {
      if(!a[b.serviceTpcd]) {
        a[b.serviceTpcd] = [b];
      }
      else {
        a[b.serviceTpcd] = a[b.serviceTpcd].concat(b);
      }
      return a;
    }, {});

    this.setState({categoryList:categoryService.data})

    // 아이디 중복체크
    $("#userIdBtn").on("click", function() {
      var userId = $("#userId").val()

      if(userId !== "") {
        axios.post(`${ LOGIN_API }/user/id/check`, {
          channelType: 2,
          loginId: String(userId)
        }).then(function(response) {
          if (response.data.testResult === false) {
            axios.post(`${ LOGIN_API }/user/id/check`, {
              channelType: 2,
              loginId: String(userId) + "_1"
            }).then(function(response) {
              if(response.data.testResult === false) {
                $("#userIdBtn").attr("data", "1");
                $("#AlertMessagePopup1_1").removeClass("hide")
              } else {
                $("#userIdBtn").attr("data", "0");
                $("#AlertMessagePopup1_2").removeClass("hide")
              }
            })
          } else {
            $("#userIdBtn").attr("data", "0");
            $("#AlertMessagePopup1_2").removeClass("hide")
          }
        })
      }
    })


    // 1번
    $(".serviceBtn").on("click", function() {
      service = $(this).val();
      $(".sec").addClass("hide");
      $(".sec2").removeClass("hide");
      $(".bottomHead").removeClass("hide")
      $(".headerLabel").removeClass("active")
      $(".headerLabel1").addClass("active")
      $("#franchiseCategory").val(service);

      $("#categoryListBox").empty()

      for(var i = 0; categoryOutput[service].length > i; i++) {
        var data = categoryOutput[service][i]
        var categoryId = "category" + data.id
        var li = document.createElement("li")
        li.innerHTML = `<input type="radio" value="${data.id}" class="eventBtn category" name="category" id="${categoryId}"><label for="${categoryId}">${data.categoryName}</label></li>`
        $("#categoryListBox").append(li)
      }

      $(".deliveryType").prop("checked", false)

      if(Number(service) === 1) {
        $(".service1").removeClass("hide")
        $(".service2").addClass("hide")
      } else {
        $(".service2").removeClass("hide")
        $(".service1").addClass("hide")
      }
    })


    // 2번
    $(".content2").on("click", ".check_all", function () {
      $(this).parents(".content2").find('input').prop("checked", $(this).is(":checked"));

      checkBox()
    });

    $(".content2").on("click", ".check", function() {
      var is_checked = true;

      $(".content2 .check").each(function(){
        is_checked = is_checked && $(this).is(":checked");
      });

      $(".check_all").prop("checked", is_checked);

      checkBox()
    });

    function checkBox() {
      let check1 = $(".content2 #check1").is(":checked");
      let check2 = $(".content2 #check2").is(":checked");

      if(check1 === true && check2 === true) {
        $(".content2 .next").addClass("active");
      } else {
        $(".content2 .next").removeClass("active");
      }
    }

    $(".sec2 .previous").on("click", function() {
      $(".sec").addClass("hide");
      $(".sec1").removeClass("hide");
      $(".bottomHead").addClass("hide")
      $(".headerLabel").removeClass("active")
    })

    $(".sec2 .next").on("click", function() {
      if($(this).hasClass("active") === true) {
        $(".sec").addClass("hide");
        $(".sec3").removeClass("hide");
        $(".headerLabel").removeClass("active")
        $(".headerLabel2").addClass("active")
        $("#birth").attr("readonly", true)
        $("#franchiseCategory").val(1);

        $("#categoryListBox").empty()

        for(var i = 0; categoryOutput[1].length > i; i++) {
          var data = categoryOutput[1][i]
          var categoryId = "category" + data.id
          var li = document.createElement("li")
          li.innerHTML = `<input type="radio" value="${data.id}" class="eventBtn category" name="category" id="${categoryId}"><label for="${categoryId}">${data.categoryName}</label></li>`
          $("#categoryListBox").append(li)
        }

        $(".deliveryType").prop("checked", false)

        $(".service1").removeClass("hide")
        $(".service2").addClass("hide")
      }
    })

    // 3번
    $(".sec3 .previous").click(function() {
      $(".sec").addClass("hide");
      $(".sec2").removeClass("hide");
      $(".headerLabel").removeClass("active")
      $(".headerLabel1").addClass("active")
    })

    $(".sec3 .next").click(function() {
      let userId = $("#userId").val()
      let userPw1 = $("#userPw1").val()
      let userPw2 = $("#userPw2").val()
      let franchiseName = $("#franchiseName").val()
      let realName = $("#realName").val()
      let businessNumber1 = $("#businessNumber1").val()
      let businessNumber2 = $("#businessNumber2").val()
      let businessNumber3 = $("#businessNumber3").val()
      let businessMobile2 = $("#businessMobile2").val()
      let businessMobile3 = $("#businessMobile3").val()
      let businessCondition = $("#businessCondition").val()
      let businessEvent = $("#businessEvent").val()
      let road = $("#road").val()
      let detailAddress = $("#detailAddress").val()
      let reptName = $("#reptName").val()
      let birth = $("#birth").val()
      let tel2 = $("#tel2").val()
      let tel3 = $("#tel3").val()
      let email1 = $("#email1").val()
      let email2 = $("#email2").val()
      let result = $("#userIdBtn").attr("data");
      // let result2 = $("#codeBtn").attr("data");

      let businessClass = $('input[name=businessClass]:checked').val()
      let corporation1 = $("#corporation1").val()
      let corporation2 = $("#corporation2").val()

      if(Number(businessClass) === 2) {
        if(corporation1.length !== 6) {
          $("#AlertMessagePopup1_8").removeClass("hide")
          $("#corporation1").focus()
          return false
        }
        if(corporation2.length !== 7) {
          $("#AlertMessagePopup1_8").removeClass("hide")
          $("#corporation2").focus()
          return false
        }
      }

      if(userId === "") {
        $("#AlertMessagePopup3_2").removeClass("hide")
        $("#userId").focus()
        return false
      }
      if(result === "0") {
        $("#AlertMessagePopup3_3").removeClass("hide")
        $("#userId").focus()
        return false
      }

      if(userPw1.length < 8) {
        $("#AlertMessagePopup3_4").removeClass("hide")
        $("#userPw1").focus()
        return false
      } else {
        if(!pwChk.test(userPw1)) {
          $("#AlertMessagePopup3_4").removeClass("hide")
          $("#userPw1").focus()
          return false;
        }
      }

      if(userPw1 !== userPw2) {
        $("#AlertMessagePopup3_5").removeClass("hide")
        $("#userPw2").focus()
        return false
      }
      if(franchiseName === "") {
        $("#AlertMessagePopup3_6").removeClass("hide")
        $("#franchiseName").focus()
        return false
      }
      if(realName === "") {
        $("#AlertMessagePopup3_7").removeClass("hide")
        $("#realName").focus()
        return false
      }
      if(businessNumber1.length !== 3) {
        $("#AlertMessagePopup3_8").removeClass("hide")
        $("#businessNumber1").focus()
        return false
      }
      if(businessNumber2.length !== 2) {
        $("#AlertMessagePopup3_8").removeClass("hide")
        $("#businessNumber2").focus()
        return false
      }
      if(businessNumber3.length !== 5) {
        $("#AlertMessagePopup3_8").removeClass("hide")
        $("#businessNumber3").focus()
        return false
      }
      if(businessMobile2.length < 3) {
        $("#AlertMessagePopup3_9").removeClass("hide")
        $("#businessMobile2").focus()
        return false
      }
      if(businessMobile3.length !== 4) {
        $("#AlertMessagePopup3_9").removeClass("hide")
        $("#businessMobile3").focus()
        return false
      }
      if(businessCondition === "") {
        $("#AlertMessagePopup3_10").removeClass("hide")
        $("#businessCondition").focus()
        return false
      }
      if(businessEvent === "") {
        $("#AlertMessagePopup3_11").removeClass("hide")
        $("#businessEvent").focus()
        return false
      }
      if(road === "") {
        $("#AlertMessagePopup3_12").removeClass("hide")
        $("#road").focus()
        return false
      }
      if(detailAddress === "") {
        $("#AlertMessagePopup3_13").removeClass("hide")
        $("#detailAddress").focus()
        return false
      }
      if(reptName === "") {
        $("#AlertMessagePopup3_14").removeClass("hide")
        $("#reptName").focus()
        return false
      }
      if(birth === "") {
        $("#AlertMessagePopup3_15").removeClass("hide")
        $("#birth").focus()
        return false
      }
      if(tel2.length < 3) {
        $("#AlertMessagePopup3_16").removeClass("hide")
        $("#tel2").focus()
        return false
      }
      if(tel3.length !== 4) {
        $("#AlertMessagePopup3_16").removeClass("hide")
        $("#tel3").focus()
        return false
      }
      // if(result2 === "0") {
      //   $("#AlertMessagePopup3_1").removeClass("hide")
      //   $("#verificationCode").focus()
      //   return false
      // }
      if(email1 === "") {
        $("#AlertMessagePopup3_17").removeClass("hide")
        $("#email1").focus()
        return false
      }
      if(email2 === "") {
        $("#AlertMessagePopup3_17").removeClass("hide")
        $("#email2").focus()
        return false
      }

      $(".sec").addClass("hide");
      $(".sec4").removeClass("hide");
      $(".headerLabel").removeClass("active")
      $(".headerLabel3").addClass("active")
    });

    // 4번
    $(".sec4 .previous").click(function() {
      $(".sec").addClass("hide");
      $(".sec3").removeClass("hide");
      $(".headerLabel").removeClass("active")
      $(".headerLabel2").addClass("active")
    })

    $(".sec4 .next").click(function() {
      let acntHolder = $("#acntHolder").val()
      let bankAcnt = $("#bankAcnt").val()

      if(acntHolder === "") {
        $("#AlertMessagePopup4_1").removeClass("hide")
        $("#acntHolder").focus()
        return false
      }
      if(bankAcnt === "") {
        $("#AlertMessagePopup4_2").removeClass("hide")
        $("#bankAcnt").focus()
        return false
      }

      $(".sec").addClass("hide");
      $(".sec5").removeClass("hide");
      $(".headerLabel").removeClass("active")
      $(".headerLabel4").addClass("active")
    })

    // 5번
    $("#businessLicense").change(function() {
      var fileName = $("#businessLicense").val();
      $("#businessLicenseName").val(fileName);
    })
    $("#identificationCard").change(function() {
      var fileName = $("#identificationCard").val();
      $("#identificationCardName").val(fileName);
    })
    $("#passbook").change(function() {
      var fileName = $("#passbook").val();
      $("#passbookName").val(fileName);
    })
    $("#businessReport").change(function() {
      var fileName = $("#businessReport").val();
      $("#businessReportName").val(fileName);
    })

    $(".sec5 .previous").click(function() {
      $(".sec").addClass("hide");
      $(".sec4").removeClass("hide");
      $(".headerLabel").removeClass("active")
      $(".headerLabel3").addClass("active")
    })

    $(".sec5 .next").click(function() {
      let businessLicense = $("#file1").val()
      let identificationCard = $("#file2").val()
      let passbook = $("#file3").val()
      let businessReport = $("#file4").val()

      if(businessLicense === "") {
        $("#AlertMessagePopup5_1").removeClass("hide")
        $("#file1").focus()
        return false
      }
      if(identificationCard === "") {
        $("#AlertMessagePopup5_2").removeClass("hide")
        $("#file2").focus()
        return false
      }
      if(passbook === "") {
        $("#AlertMessagePopup5_3").removeClass("hide")
        $("#file3").focus()
        return false
      }

      $(".sec").addClass("hide");
      $(".sec6").removeClass("hide");
      $(".headerLabel").removeClass("active")
      $(".headerLabel5").addClass("active")
    })

    // 6번
    $(".sec6 .previous").click(function() {
      $(".sec").addClass("hide");
      $(".sec5").removeClass("hide");
      $(".headerLabel").removeClass("active")
      $(".headerLabel4").addClass("active")
    })
  }

  constructor() {
    super();

    this.state = {
      file1: "",
      file2: "",
      file3: "",
      file4: "",
      categoryList: [],
    }
  }

  // 이미지 업로드 함수
  imageChange = (e) => {
    let file = e.target
    let fileId = e.target.id

    // 이미지 정보 인코딩
    var fileReader = new FileReader()
    fileReader.onload = (base64) => {
      const image = new Image()

      image.src = base64.target.result

      image.onload = (e) => {
        var arr1 = file.files[0].name.split('.');
        var arr2 = base64.target.result.split(',')
        var fileImg

        if(fileId === "file1") {
          fileImg = {
            imageType: 1,
            encodedFile: arr2[1],
            fileName: arr1[0] + "_1",
            fileExtension: "jpeg"
          }
          this.setState({file1: fileImg})
        } else if(fileId === "file2") {
          fileImg = {
            imageType: 2,
            encodedFile: arr2[1],
            fileName: arr1[0] + "_2",
            fileExtension: "jpeg"
          }
          this.setState({file2: fileImg})
        } else if(fileId === "file3") {
          fileImg = {
            imageType: 3,
            encodedFile: arr2[1],
            fileName: arr1[0] + "_3",
            fileExtension: "jpeg"
          }
          this.setState({file3: fileImg})
        } else if(fileId === "file4") {
          fileImg = {
            imageType: 4,
            encodedFile: arr2[1],
            fileName: arr1[0] + "_4",
            fileExtension: "jpeg"
          }
          this.setState({file4: fileImg})
        }
      }
    }

    fileReader.readAsDataURL(file.files[0]);
  }

  render() {
    // api 주소호출
    // const outsideOrderUrl = "http://3.36.71.204:50004";
    // const orderUrl = "http://3.34.201.152:50000";

    let file = this.state;

    $(".addBtn").off("click").on("click", async function () {
      const getVal = id => $(`#${id}`).val();
      const concatVal = (...ids) => ids.map(id => getVal(id)).join('');
      const getRadioVal = name => $(`input[name=${name}]:checked`).val();

      // 파일 수집
      const fileList = [];
      if (file.file1 !== "") fileList.push(file.file1);
      if (file.file2 !== "") fileList.push(file.file2);
      if (file.file3 !== "") fileList.push(file.file3);
      if (file.file4 !== "") fileList.push(file.file4);

      // 체크박스
      const check4 = $(".content2 #check4").is(":checked");

      // 기본 값 수집
      const userId = getVal("userId").trim();
      const userPw1 = getVal("userPw1");
      const franchiseName = getVal("franchiseName");
      const realName = getVal("realName");
      const businessClass = Number(getRadioVal("businessClass"));
      const businessNumber = concatVal("businessNumber1", "businessNumber2", "businessNumber3");
      const corporation = concatVal("corporation1", "corporation2");
      const businessMobile = concatVal("businessMobile1", "businessMobile2", "businessMobile3");
      const businessCondition = getVal("businessCondition");
      const businessEvent = getVal("businessEvent");
      const road = getVal("road");
      const detailAddress = getVal("detailAddress");
      const lat = getVal("lat");
      const lng = getVal("lng");
      const jibun = getVal("jibun");
      const reptName = getVal("reptName");
      const birth = getVal("birth");
      const tel = concatVal("tel1", "tel2", "tel3");
      const email = `${getVal("email1")}@${getVal("email2")}`.trim();
      const bankTpcd = getVal("bankTpcd");
      const acntHolder = getVal("acntHolder");
      const bankAcnt = getVal("bankAcnt");
      const franchiseCategory = getVal("franchiseCategory");
      const category = Number(getRadioVal("category"));
      const feeType = Number(getRadioVal("feeType"));

      const menuType = getRadioVal("menuType");
      const recommender = getVal("recommender");
      const recommenderTel1 = getVal("recommenderTel1");
      const recommenderTel2 = getVal("recommenderTel2");
      const recommenderTel3 = getVal("recommenderTel3");

      if (isNaN(category)) {
        $("#AlertMessagePopup6_1").removeClass("hide");
        return false;
      }

      const deliTy = [];
      for (let i = 1; i <= 5; i++) {
        if ($(`#deliveryType${i}`).is(":checked")) {
          deliTy.push(Number($(`#deliveryType${i}`).val()));
        }
      }

      if (deliTy.length === 0) {
        $("#AlertMessagePopup6_2").removeClass("hide");
        return false;
      }

      $("#application .lodding").removeClass("hide");

      const baseRequest = {
        modifierId: 0,
        modifierType: 1,
        channelType: "2",
        userType: 1,
        loginId: userId,
        loginPassword: userPw1,
        type: 1,
        status: 6,
        approvalType1: 4,
        approvalType2: 5,
        serviceType: Number(franchiseCategory),
        upperShopId: 0,
        name: franchiseName,
        realName,
        birth,
        tel: businessNumber,
        email,
        jibun,
        road,
        addressDetail: detailAddress,
        lat: Number(lat),
        lng: Number(lng),
        bizAddress: `${road} ${detailAddress}`,
        bizType: 1,
        bizNo: businessNumber,
        corpNo: corporation,
        reptName,
        reptTel: tel,
        bizCond: businessCondition,
        bizItem: businessEvent,
        bank: Number(bankTpcd),
        bankAccountHolder: acntHolder,
        bankAccount: bankAcnt,
        doPromotionAgree: check4,
        doAutoToggleOperation: true,
        intro: "",
        notice: "",
        pauseStartDateTime: "2000-01-01 09:00:00",
        pauseEndDateTime: "2000-01-01 09:00:00",
        pauseReason: "",
        extraCost: 0,
        extraReason: "",
        minOrderCost: 0,
        pgId: "",
        zeroId: "",
        zeroAuthKey: "",
        onnuriId: "",
        onnuriAuthKey: "",
        localCurrency: 1,
        localCurrencyId: "",
        deliveryTypeList: deliTy,
        extraTypeList: [],
        packagingType: 1,
        packagingCost: 0,
        packagingDiscountCost: 0,
        tempClosingStartDate: "2000-01-01",
        tempClosingEndDate: "2000-01-01",
        tempClosingReason: "",
        deliveryDoneMinutes: 0,
        packagingDoneMinutes: 0,
        bundleDoneMinutes: 0,
        cooInfo: "",
        etc: `${recommender},${recommenderTel1}${recommenderTel2}${recommenderTel3}`,
        categoryIdList: [category],
        fileList,
      };

      const shopInfo1 = await axios.post(`${ORDER_API}/shop/v2`, baseRequest);
      const shopId = shopInfo1.data.shopId;
      const posId = shopInfo1.data.posShopId;

      await axios.post(`${ORDER_PROXY_API}/shop/v2/mapping/code`, {
        channelType: 2,
        posShopId: Number(posId),
        orderShopId: String(shopId)
      });

      const shopInfo2 = await axios.post(`${ORDER_API}/shop/v2`, {
        ...baseRequest,
        modifierType: 2,
        userType: 4,
        loginId: `${userId}_1`,
        tel: businessMobile,
        type: 4,
        status: 8,
        approvalType1: 1,
        approvalType2: 1,
        upperShopId: Number(shopId),
        doPromotionAgree: false,
        bizType: Number(businessClass),
        etc: menuType,
        feeType
      });

      const shopId2 = shopInfo2.data.shopId;
      const posId2 = shopInfo2.data.posShopId;

      await axios.post(`${ORDER_PROXY_API}/shop/v2/mapping/code`, {
        channelType: 2,
        posShopId: Number(posId2),
        orderShopId: String(shopId2)
      });

      await axios.put(`${ORDER_API}/shop/v2/${shopId2}`, {
        shopOrderSettingsList: [{
          deliveryType: 1,
          autoCancelMinutes: "10",
          autoDoneMinutes: "120"
        }, {
          deliveryType: 2,
          autoCancelMinutes: "10",
          autoDoneMinutes: "120"
        }]
      });

      for (const type of deliTy) {
        await axios.post(`${POS_API}/shop/v2/auto-process`, {
          shopId: posId2,
          deliveryType: type,
          autoCompleteTime: 120,
          autoCancelTime: 10
        });
      }

      window.location.href = "/v2";
    });

    return(
      <main id='application' className='DongApplicationV2'>
        <div className='lodding hide'></div>
        <div className='width590'>
          <header id='applicationHead'>
            <div className='topHead'>
              <HeadText />
            </div>
            <div className='bottomHead'>
              <div className='headerLabel headerLabel1 active'>
                <p><span>01</span>약관동의</p>
              </div>
              <img src={ arrow } alt="" className="arrowImg" />
              <div className='headerLabel headerLabel2'>
                <p><span>02</span>사업자 정보</p>
              </div>
              <img src={ arrow } alt="" className="arrowImg" />
              <div className='headerLabel headerLabel3'>
                <p><span>03</span>정산 정보</p>
              </div>
              <img src={ arrow } alt="" className="arrowImg" />
              <div className='headerLabel headerLabel4'>
                <p><span>04</span>제출 서류</p>
              </div>
              <img src={ arrow } alt="" className="arrowImg" />
              <div className='headerLabel headerLabel5'>
                <p><span>05</span>매장 정보</p>
              </div>
            </div>
          </header>

          <section className='sec sec1 hide'>
            <div className='applicationInner'>
              <h3>가맹점 입점 유형 선택</h3>
              <p>입점을 신청하실 유형을 선택해주세요.</p>
              <div className='flex'>
                <button type='button' className='serviceBtn' value={1}>
                  <img src={service1} alt='음식배달 입점신청' />
                </button>
                <button type='button' className='serviceBtn' value={6}>
                  <img src={service2} alt='전통시장 입점신청' />
                </button>
                <input type='text' className='hide' id='franchiseCategory' name='franchiseCategory' />
              </div>
            </div>
          </section>

          <section className='sec sec2'>
            <div className='applicationSubTitle'>
              <div className='applicationInner'>
                <h3>안내사항 및 약관 동의</h3>
              </div>
            </div>
            <div className='applicationInner'>
              <div className='content1'>
                <h2>안내사항</h2>
                <div className='box'>
                  <ul>
                    {/**
                     <li>
                     <p>● 이용가이드</p>
                     <p className='underLine'>준비중 입니다.</p>
                     </li>
                     */}
                    <li>
                      <p>● 카카오톡 채널 : <a href="https://pf.kakao.com/_HpQqn" target="_blank" rel='noopener noreferrer'>https://pf.kakao.com/_HpQqn</a></p>
                      {/* <p>
                        <a href="https://pf.kakao.com/_HpQqn" target="_blank" rel='noopener noreferrer'>https://pf.kakao.com/_HpQqn</a>
                      </p> */}
                    </li>
                    <li>
                      <p>● 고객센터 : 1800-9991 &nbsp;&nbsp;<span className="gray">※ 꼭! 저장 부탁드립니다.</span></p>
                      {/* <p>1800-9991<span className="gray">※ 꼭! 저장 부탁드립니다.</span></p> */}
                    </li>
                    <li>
                      <p>● 수수료 정책 <br />
                      &nbsp;&nbsp;&nbsp;  - 월 99,000원 (VAT 포함) 기본<br />
                      &nbsp;&nbsp;&nbsp;  - 월 55,000원 (VAT 포함) 월 매출 (200만원 미만)<br />
                      &nbsp;&nbsp;&nbsp;  - 중개 수수료 무료<br />
                      &nbsp;&nbsp;&nbsp;  - 결제 수수료 3.3% (VAT 포함)
                      </p>
                      {/* <div className="textBox"> */}
                        {/* <p> */}
                          {/* <span className="fw-7">가맹비 타입</span><br/>
                          - 월 99,000원 (VAT 포함) 기본<br />
                          - 월 55,000원 (VAT 포함) 월 매출 (200만원 미만)<br />
                          - 중개 수수료 무료<br />
                          - 결제 수수료 3.3% (VAT 포함) */}
                          {/* 99,000원(VAT포함)/월 (기본) 55,000원(VAT포함)/
                          월 (100건미만) 가입 시 중개 수수료 무료,
                          결제수수료 3.3%(VAT 포함) */}
                        {/* </p> */}
                        {/* <p>
                          <span className="fw-7">수수료 타입</span><br/>
                          중개 수수료 5.5%(VAT 포함) (가맹비로 전환 가능)
                          결제 수수료 3.3%(VAT 포함)
                        </p>
                        <p>※ 첫 타입 설정은 입점신청에서 가능합니다.</p>
                        <p>※ 타입 변경 및 문의사항은 고객센터로 연락 부탁드립니다.</p> */}
                      {/* </div> */}
                    </li>
                  </ul>
                </div>
              </div>
              <div className='content2'>
                <h2>약관 동의</h2>
                <input type="checkbox" className="check_all" id="checkAll" />
                <label className="allCheck" htmlFor="checkAll">
                  <h3>모두 동의합니다.</h3>
                </label>
                <input type="checkbox" className="check" id="check1" />
                <label htmlFor="check1">
                  <h4>띵동 서비스 이용약관<span> (필수)</span></h4>
                </label>
                <div className='box'>
                  <DongDeliveryService />
                </div>
                <input type="checkbox" className="check" id="check2" />
                <label htmlFor="check2">
                  <h4>개인정보 수집·이용·위탁 / 제 3자 제공동의서<span> (필수)</span></h4>
                </label>
                <div className='box'>
                  <DongPrivate />
                </div>

                <div className="pageBtn flex">
                  {/*<button type="button" className="previous">이전</button>*/}
                  <button type="button" className="next width100">다음</button>
                </div>
              </div>
            </div>
          </section>

          <section className='sec sec3 hide'>
            <div className='applicationSubTitle'>
              <div className='applicationInner'>
                <h3>사업자 정보</h3>
                <span>사업자등록증 정보와 동일하게 입력해주세요.</span>
              </div>
            </div>
            <div className='applicationInner'>
              <div className='content1'>
                <div className='inputBox'>
                  <h2>아이디</h2>
                  <input type='text' className='text userId eng' id='userId' name='userId' maxLength={16} onInput={(e) => (e.target.value = e.target.value.replace(/\s/g, ""))} />
                  <button id='userIdBtn' className='btn' type='button' data='0'>중복확인</button>
                  <p>※ 아이디를 연락처로 입력하셔도 됩니다.</p>
                </div>
                <div className='inputBox'>
                  <h2>비밀번호</h2>
                  <input type='password' className='text userPw1' id='userPw1' name='userPw1' maxLength={16} placeholder="비밀번호" autoComplete="off" />
                  <p>※ 비밀번호는 영문, 숫자, 특수문자 조합으로 8자리 이상 입력해주세요.</p>
                </div>
                <div className='inputBox'>
                  <h2>비밀번호 확인</h2>
                  <input type='password' className='text userPw2' id='userPw2' name='userPw2' maxLength={16} placeholder="비밀번호" autoComplete="off" />
                </div>
                <div className='inputBox'>
                  <h2>사업자등록증 상호명</h2>
                  <input type='text' className='text realName' id="realName" name="realName" maxLength={30} placeholder="사업자등록증과 동일하게 입력" />
                </div>
                <div className='inputBox'>
                  <h2>상점명</h2>
                  <input type='text' className='text franchiseName' id="franchiseName" name="franchiseName" maxLength={30} placeholder="고객에게 노출되는 상점명 입력" />
                </div>
                <div className='inputBox businessClassBox'>
                  <h2>사업자 구분</h2>
                  <div className='d-flex a-center j-left'>
                    <input type='radio' value={1} className='businessClass' id='businessClass1' name='businessClass' defaultChecked />
                    <label htmlFor='businessClass1' className='businessClass1'>일반 사업자</label>
                    <input type='radio' value={2} className='businessClass' id='businessClass2' name='businessClass' />
                    <label htmlFor='businessClass2'>법인 사업자</label>
                  </div>
                </div>
                <div className='inputBox'>
                  <h2>사업자등록번호</h2>
                  <div className='d-flex a-center j-left'>
                    <input
                      type='number' className='text number businessNumber' name="businessNumber1" id="businessNumber1" maxLength="3" placeholder="3자리"
                      onInput={(e) => {
                        if (e.target.value.length > e.target.maxLength)
                          e.target.value = e.target.value.slice(0, e.target.maxLength);
                      }}
                    />
                    <p>-</p>
                    <input
                      type='number' className='text number businessNumber' name="businessNumber2" id="businessNumber2" maxLength="2" placeholder="2자리"
                      onInput={(e) => {
                        if (e.target.value.length > e.target.maxLength)
                          e.target.value = e.target.value.slice(0, e.target.maxLength);
                      }}
                    />
                    <p>-</p>
                    <input
                      type='number' className='text number businessNumber' name="businessNumber3" id="businessNumber3" maxLength="5" placeholder="5자리"
                      onInput={(e) => {
                        if (e.target.value.length > e.target.maxLength)
                          e.target.value = e.target.value.slice(0, e.target.maxLength);
                      }}
                    />
                  </div>
                </div>
                <div className='inputBox corporationBox hide'>
                  <h2>법인등록번호<span>(법인만 입력)</span></h2>
                  <div className='flex'>
                    <input
                      type="number" className="text number corporation" id="corporation1" name="corporation1" maxLength="6" placeholder="6자리"
                      onInput={(e) => {
                        if (e.target.value.length > e.target.maxLength)
                          e.target.value = e.target.value.slice(0, e.target.maxLength);
                      }}
                    />
                    <p>-</p>
                    <input
                      type="number" className="text number corporation" id="corporation2" name="corporation2" maxLength="7" placeholder="7자리"
                      onInput={(e) => {
                        if (e.target.value.length > e.target.maxLength)
                          e.target.value = e.target.value.slice(0, e.target.maxLength);
                      }}
                    />
                  </div>
                </div>
                <div className='inputBox'>
                  <h2>사업장 전화번호</h2>
                  <div className='d-flex a-center j-left'>
                    <select className="select businessMobile" id="businessMobile1" name="businessMobile1">
                      <option value="010">010</option>
                      <option value="070">070</option>
                      <option value="02">02</option>
                      <option value="031">031</option>
                      <option value="032">032</option>
                      <option value="033">033</option>
                      <option value="041">041</option>
                      <option value="042">042</option>
                      <option value="043">043</option>
                      <option value="051">051</option>
                      <option value="052">052</option>
                      <option value="053">053</option>
                      <option value="054">054</option>
                      <option value="055">055</option>
                      <option value="061">061</option>
                      <option value="062">062</option>
                      <option value="063">063</option>
                      <option value="064">064</option>
                    </select>
                    <p>-</p>
                    <input
                      type="number" className="text number businessMobile" id="businessMobile2" name="businessMobile2" maxLength="4" placeholder="3~4자리"
                      onInput={(e) => {
                        if (e.target.value.length > e.target.maxLength)
                          e.target.value = e.target.value.slice(0, e.target.maxLength);
                      }}
                    />
                    <p>-</p>
                    <input
                      type="number" className="text number businessMobile" id="businessMobile3" name="businessMobile3" maxLength="4" placeholder="4자리"
                      onInput={(e) => {
                        if (e.target.value.length > e.target.maxLength)
                          e.target.value = e.target.value.slice(0, e.target.maxLength);
                      }}
                    />
                  </div>
                </div>
                <div className='inputBox'>
                  <h2>업태</h2>
                  <input type="text" className="text businessCondition" id="businessCondition" name="businessCondition" placeholder="사업자등록증 업태 입력" maxLength='20' />
                </div>
                <div className='inputBox'>
                  <h2>종목</h2>
                  <input type="text" className="text businessEvent" id="businessEvent" name="businessEvent" placeholder="사업자등록증 종목 입력" maxLength='20' />
                </div>
                <div className='inputBox'>
                  <h2>상점 주소</h2>
                  <div className="flex mb-5">
                    <input type="text" className="text address" id="road" name="address" placeholder="주소를 검색하여 입력" readOnly />
                    <Post />
                  </div>
                  <input type="text" className="text detailAddress" id="detailAddress" name="detailAddress1" placeholder="상세 주소" maxLength={30} />
                  <input type="hidden" name="lat" id="lat" />
                  <input type="hidden" name="lng" id="lng" />
                  <input type="hidden" name="jibun" id="jibun" />
                </div>
                <div className='inputBox'>
                  <h2>대표자명</h2>
                  <input type='text' className='text reptName' id="reptName" name="reptName" placeholder="사업자등록증 대표명" maxLength={20} />
                </div>
                <div className='inputBox'>
                  <h2>생년월일</h2>
                  <DataPicker2 id="birth" name="birth" day={null} />
                </div>
                <div className='inputBox'>
                  <h2>대표자 연락처</h2>
                  <div className='d-flex a-center j-left'>
                    <select className="select businessMobile" id="tel1" name="tel1">
                      <option value="010">010</option>
                      <option value="070">070</option>
                    </select>
                    <p>-</p>
                    <input
                      type="number" className="text number businessMobile" id="tel2" name="tel2" maxLength="4" placeholder="4자리"
                      onInput={(e) => {
                        if (e.target.value.length > e.target.maxLength)
                          e.target.value = e.target.value.slice(0, e.target.maxLength);
                      }}
                    />
                    <p>-</p>
                    <input
                      type="number" className="text number businessMobile" id="tel3" name="tel3" maxLength="4" placeholder="4자리"
                      onInput={(e) => {
                        if (e.target.value.length > e.target.maxLength)
                          e.target.value = e.target.value.slice(0, e.target.maxLength);
                      }}
                    />
                    {/* <button id='mobileBtn' className='btn mobileBtn' type='button' data='0'>본인인증</button> */}
                  </div>
                  <div className='d-flex a-center j-left mt-5'>
                    <input
                      type="number" className="text number verificationCode hide" id="verificationCode" name="verificationCode" maxLength="6" placeholder="6자리"
                      onInput={(e) => {
                        if (e.target.value.length > e.target.maxLength)
                          e.target.value = e.target.value.slice(0, e.target.maxLength);
                      }}
                    />
                    <button id='codeBtn' className='btn mobileCheckBtn hide' type='button' data='0'>인증확인</button>
                  </div>
                </div>
                <div className="inputBox">
                  <h2>이메일 주소</h2>
                  <div className="d-flex a-center j-left">
                    <input type="text" className="text eng email" id="email1" name="email1" placeholder="이메일 입력(세금계산서 수신용)" maxLength={16} />
                    <p>@</p>
                    <input type="text" className="text eng email" id="email2" name="email2" maxLength={15} />
                    <select className="select email" id="email3" name="email3">
                      <option value="">직접입력</option>
                      <option value="naver.com">naver.com</option>
                      <option value="gmail.com">gmail.com</option>
                      <option value="hanmail.net">hanmail.net</option>
                      <option value="nate.com">nate.com</option>
                    </select>
                  </div>
                </div>
                <div className='inputBox'>
                  <h2>추천인</h2>
                  <input type='text' className='text recommender' id="recommender" name="recommender" placeholder="추천인" maxLength={10} />
                </div>
                <div className='inputBox'>
                  <h2>추천인 연락처</h2>
                  <div className='d-flex a-center j-left'>
                    <select className="select businessMobile" id="recommenderTel1" name="recommenderTel1">
                      <option value="010">010</option>
                      <option value="070">070</option>
                    </select>
                    <p>-</p>
                    <input
                      type="number" className="text number businessMobile" id="recommenderTel2" name="recommenderTel2" maxLength="4" placeholder="4자리"
                      onInput={(e) => {
                        if (e.target.value.length > e.target.maxLength)
                          e.target.value = e.target.value.slice(0, e.target.maxLength);
                      }}
                    />
                    <p>-</p>
                    <input
                      type="number" className="text number businessMobile" id="recommenderTel3" name="recommenderTel3" maxLength="4" placeholder="4자리"
                      onInput={(e) => {
                        if (e.target.value.length > e.target.maxLength)
                          e.target.value = e.target.value.slice(0, e.target.maxLength);
                      }}
                    />
                  </div>
                </div>
                <div className="pageBtn flex">
                  <button type="button" className="previous">이전</button>
                  <button type="button" className="next active">다음</button>
                </div>
              </div>
            </div>
          </section>

          <section className='sec sec4 hide'>
            <div className='applicationSubTitle'>
              <div className='applicationInner'>
                <h3>정산 정보</h3>
              </div>
            </div>
            <div className='applicationInner'>
              <div className='content1'>
                <div className='inputBox'>
                  <h2>은행명</h2>
                  <select className="select bankTpcd" id="bankTpcd" name="bankTpcd">
                    <option value={1}>산업은행</option>
                    <option value={2}>기업은행</option>
                    <option value={3}>국민은행</option>
                    <option value={4}>외환은행</option>
                    <option value={5}>수협</option>
                    <option value={6}>농협</option>
                    <option value={7}>우리은행</option>
                    <option value={8}>제일은행</option>
                    <option value={9}>시티은행</option>
                    <option value={10}>대구은행</option>
                    <option value={11}>부산은행</option>
                    <option value={12}>광주은행</option>
                    <option value={13}>제주은행</option>
                    <option value={14}>전북은행</option>
                    <option value={15}>경남은행</option>
                    <option value={16}>새마을금고</option>
                    <option value={17}>신협</option>
                    <option value={18}>우체국은행</option>
                    <option value={19}>하나은행</option>
                    <option value={20}>신한은행</option>
                    <option value={21}>카카오뱅크</option>
                    <option value={22}>케이뱅크</option>
                    <option value={23}>토스뱅크</option>
                    <option value={24}>한국은행</option>
                    <option value={25}>한국수출입은행</option>
                    <option value={26}>지역농∙축협</option>
                    <option value={27}>저축은행</option>
                  </select>
                </div>
                <div className='inputBox'>
                  <h2>예금주</h2>
                  <input type='text' className='text acntHolder' id='acntHolder' name='acntHolder' maxLength={20} />
                </div>
                <div className='inputBox'>
                  <h2>계좌번호</h2>
                  <input type='number' className='text bankAcnt' id='bankAcnt' name='bankAcnt' maxLength={20}
                         onInput={(e) => {
                           if (e.target.value.length > e.target.maxLength)
                             e.target.value = e.target.value.slice(0, e.target.maxLength);
                         }}
                  />
                </div>
                <div className="pageBtn flex">
                  <button type="button" className="previous">이전</button>
                  <button type="button" className="next active">다음</button>
                </div>
              </div>
            </div>
          </section>

          <section className='sec sec5 hide'>
            <div className="applicationSubTitle">
              <div className="applicationInner">
                <h3>제출 서류</h3>
                <span>모바일은 제출서류를 카메라로 찍어서 쉽게 등록할 수 있습니다.</span>
              </div>
            </div>
            <div className="applicationInner">
              <div className="content1">
                <div className="inputBox">
                  <h2>사업자 등록증</h2>
                  <div className="flex">
                    <input type="file" className="file text" accept="image/*" id="file1" onChange={this.imageChange} />
                  </div>
                </div>
                <div className="inputBox">
                  <h2>본인(대표자) 신분증<br /><p className="red">※ 주민등록번호 뒷자리 식별이 가능해야 정상적으로 처리됩니다.</p></h2>
                  <div className="flex">
                    <input type="file" className="file text" accept="image/*" id="file2" onChange={this.imageChange} />
                  </div>
                </div>
                <div className="inputBox">
                  <h2>통장사본</h2>
                  <div className="flex">
                    <input type="file" className="file text" accept="image/*" id="file3" onChange={this.imageChange} />
                  </div>
                </div>
                <div className="inputBox businessReportBox">
                  <h2>영업신고증/통신판매업 신고증</h2>
                  <div className="flex">
                    <input type="file" className="file text" accept="image/*" id="file4" onChange={this.imageChange} />
                  </div>
                </div>
                <div className="pageBtn flex">
                  <button type="button" className="previous">이전</button>
                  <button type="button" className="next active sec5Btn">다음</button>
                </div>
              </div>
            </div>
          </section>

          <section className='sec sec6 hide'>
            <div className="applicationSubTitle">
              <div className="applicationInner">
                <h3>매장 정보</h3>
              </div>
            </div>
            <div className="applicationInner">
              <div className="content1">
                <div className="inputBox">
                  <h2>카테고리</h2>
                  <ul className="formUl deliveryList" id="categoryListBox">

                  </ul>
                </div>
                <div className="inputBox">
                  <h2>배송방법</h2>
                  <ul className="deliveryTypeBox">
                    <li className='service1'>
                      <input type="checkbox" className="deliveryType" value={1} name="deliveryType" id="deliveryType1" />
                      <label htmlFor="deliveryType1"><h4>배달주문</h4></label>
                    </li>
                    <li className='service1'>
                      <input type="checkbox" className="deliveryType" value={2} name="deliveryType" id="deliveryType2" />
                      <label htmlFor="deliveryType2"><h4>포장주문</h4></label>
                    </li>
                    <li className='service2'>
                      <input type="checkbox" className="deliveryType" value={4} name="deliveryType" id="deliveryType4" />
                      <label htmlFor="deliveryType4"><h4>택배배송</h4></label>
                    </li>
                  </ul>
                </div>
                <div className='inputBox'>
                  <h2>메뉴등록</h2>
                  <ul className="deliveryList">
                    <li>
                      <input type="radio" className="menuType" value={"배민동일"} name="menuType" id="menuType1" defaultChecked />
                      <label htmlFor="menuType1"><h4>배민동일</h4></label>
                    </li>
                    <li>
                      <input type="radio" className="menuType" value={"요기요동일"} name="menuType" id="menuType2" />
                      <label htmlFor="menuType2"><h4>요기요동일</h4></label>
                    </li>
                    <li>
                      <input type="radio" className="menuType" value={"쿠팡동일"} name="menuType" id="menuType3" />
                      <label htmlFor="menuType3"><h4>쿠팡동일</h4></label>
                    </li>
                    <li>
                      <input type="radio" className="menuType" value={"기타"} name="menuType" id="menuType4" />
                      <label htmlFor="menuType4"><h4>기타</h4></label>
                    </li>
                  </ul>
                </div>
                <div className='inputBox businessClassBox'>
                  <h2>수수료 타입</h2>
                  <div className='d-flex a-center j-left'>
                    <input type='radio' value={1} className='businessClass' id='feeType1' name='feeType' defaultChecked />
                    <label htmlFor='feeType1' className='feeType1'>가맹비 타입</label>
                    {/* <input type='radio' value={2} className='businessClass' id='feeType2' name='feeType' />
                    <label htmlFor='feeType2' className='feeType1'>수수료 타입</label> */}
                  </div>
                  <div className="feeBox">
                    <p className="bold">*가맹비 타입</p>
                    <p>
                      - 월 99,000원 (VAT 포함) 기본<br />
                      - 월 55,000원 (VAT 포함) 월 매출 (200만원 미만)<br />
                      - 중개 수수료 무료<br />
                      - 결제 수수료 3.3% (VAT 포함)
                    </p>
                    {/* <p className="bold">* 수수료 타입</p>
                    <p>중개 수수료 5.5%(VAT 포함) (가맹비로 전환 가능) 결제 수수료 3.3%(VAT 포함)</p>
                    <p>※ 첫 타입 설정은 사장님 사이트에서 가능합니다.</p>
                    <p>※ 타입 변경 및 문의사항은 고객센터로 연락 부탁드립니다.</p> */}
                  </div>
                </div>
                <div className="pageBtn flex">
                  <button type="button" className="previous">이전</button>
                  <button type="button" className="next active addBtn">신청</button>
                </div>
              </div>
            </div>
          </section>
        </div>
        <div>
          <AlertMessagePopup
            id={"AlertMessagePopup1_1"}
            title={"사용할 수 있는 아이디입니다."}
            text={""}
          />
          <AlertMessagePopup
            id={"AlertMessagePopup1_2"}
            title={"사용할 수 없는 아이디입니다."}
            text={""}
          />
          <AlertMessagePopup
            id={"AlertMessagePopup1_3"}
            title={"본인인증에 실패했습니다."}
            text={""}
          />
          <AlertMessagePopup
            id={"AlertMessagePopup1_4"}
            title={"본인인증에 성공했습니다."}
            text={""}
          />
          <AlertMessagePopup
            id={"AlertMessagePopup1_5"}
            title={"본인인증 코드를 입력해주세요."}
            text={""}
          />
          <AlertMessagePopup
            id={"AlertMessagePopup1_6"}
            title={"형식에 맞지 않는 번호입니다."}
            text={""}
          />
          <AlertMessagePopup
            id={"AlertMessagePopup1_7"}
            title={"11자리 연락처를 입력해주세요."}
            text={""}
          />
          <AlertMessagePopup
            id={"AlertMessagePopup1_8"}
            title={"법인번호를 제대로 입력해주세요"}
            text={""}
          />
          <AlertMessagePopup
            id={"AlertMessagePopup1_9"}
            title={"이미 등록된 연락처입니다."}
            text={""}
          />
          <AlertMessagePopup
            id={"AlertMessagePopup1_10"}
            title={"이미 등록된 사업자번호입니다."}
            text={""}
          />
          <AlertMessagePopup
            id={"AlertMessagePopup3_1"}
            title={"본인인증을 해주세요."}
            text={""}
          />
          <AlertMessagePopup
            id={"AlertMessagePopup3_2"}
            title={"아이디를 입력해주세요."}
            text={""}
          />
          <AlertMessagePopup
            id={"AlertMessagePopup3_3"}
            title={"아이디 중복체크를 해주세요."}
            text={""}
          />
          <AlertMessagePopup
            id={"AlertMessagePopup3_4"}
            title={"영문, 숫자, 특수문자 조합으로 8자리 이상 비밀번호를 입력해주세요."}
            text={""}
          />
          <AlertMessagePopup
            id={"AlertMessagePopup3_5"}
            title={"비밀번호가 일치하지 않습니다."}
            text={""}
          />
          <AlertMessagePopup
            id={"AlertMessagePopup3_6"}
            title={"상점명을 입력해주세요."}
            text={""}
          />
          <AlertMessagePopup
            id={"AlertMessagePopup3_7"}
            title={"실제 상점명을 입력해주세요."}
            text={""}
          />
          <AlertMessagePopup
            id={"AlertMessagePopup3_8"}
            title={"사업자번호를 제대로 입력해주세요."}
            text={""}
          />
          <AlertMessagePopup
            id={"AlertMessagePopup3_9"}
            title={"사업장 전화번호를 제대로 입력해주세요."}
            text={""}
          />
          <AlertMessagePopup
            id={"AlertMessagePopup3_10"}
            title={"업태를 입력해주세요."}
            text={""}
          />
          <AlertMessagePopup
            id={"AlertMessagePopup3_11"}
            title={"종목을 입력해주세요."}
            text={""}
          />
          <AlertMessagePopup
            id={"AlertMessagePopup3_12"}
            title={"주소를 입력해주세요."}
            text={""}
          />
          <AlertMessagePopup
            id={"AlertMessagePopup3_13"}
            title={"상세주소를 입력해주세요."}
            text={""}
          />
          <AlertMessagePopup
            id={"AlertMessagePopup3_14"}
            title={"대표자명을 입력해주세요."}
            text={""}
          />
          <AlertMessagePopup
            id={"AlertMessagePopup3_15"}
            title={"생일을 입력해주세요."}
            text={""}
          />
          <AlertMessagePopup
            id={"AlertMessagePopup3_16"}
            title={"대표자 연락처를 제대로 입력해주세요."}
            text={""}
          />
          <AlertMessagePopup
            id={"AlertMessagePopup3_17"}
            title={"이메일을 입력해주세요."}
            text={""}
          />
          <AlertMessagePopup
            id={"AlertMessagePopup4_1"}
            title={"예금주를 입력해주세요."}
            text={""}
          />
          <AlertMessagePopup
            id={"AlertMessagePopup4_2"}
            title={"계좌번호를 입력해주세요."}
            text={""}
          />
          <AlertMessagePopup
            id={"AlertMessagePopup5_1"}
            title={"사업자 등록증을 업로드해주세요."}
            text={""}
          />
          <AlertMessagePopup
            id={"AlertMessagePopup5_2"}
            title={"신분증을 업로드해주세요."}
            text={""}
          />
          <AlertMessagePopup
            id={"AlertMessagePopup5_3"}
            title={"통장사본을 업로드해주세요."}
            text={""}
          />
          <AlertMessagePopup
            id={"AlertMessagePopup5_4"}
            title={"영업신고증을 업로드해주세요."}
            text={""}
          />
          <AlertMessagePopup
            id={"AlertMessagePopup6_1"}
            title={"카테고리를 선택해주세요."}
            text={""}
          />
          <AlertMessagePopup
            id={"AlertMessagePopup6_2"}
            title={"배송방법을 선택해주세요."}
            text={""}
          />
        </div>
      </main>
    )
  }
}

export { DongApplicationV2 }